export default __webpack_public_path__ + "70685d052b02359609ef615b09b9a2fd.jpg";